import { defineMessages } from 'react-intl';

export default defineMessages({
  avatarCardDeletePhotoTitle: {
    id: 'common.components.avatar.card.delete.photo.title',
    defaultMessage: 'Delete',
  },
});
